module.exports = __webpack_public_path__ + "static/media/ic_invest_learn.ed1447a1.svg";